import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { CmsService } from '../../cms.service';
import { ConnectService } from '../../connect.service';
import * as PrismicDOM from 'prismic-dom';
import * as _ from 'lodash';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.css']
})
export class CategoryComponent implements OnInit {

  public content;
  public slug:string;
  public activeProduct;
  public activeIndex = 0;
  public products;
  public page:number;
  public totalPages:number;
  public loadingProducts:boolean;
  public lowerIndex = 0;
  public upperIndex = 3;


  public connect = () => this.connectService.toggleConnect(true);


  public generateMarkup(data) {
    return PrismicDOM.RichText.asHtml(data);
  }

  public incrementIndex () {
    if (this.activeIndex + 1 < this.content.data.products.length) {
      if (this.activeIndex === this.upperIndex) {
        this.upperIndex++;
        this.lowerIndex++;
        // if (this.upperIndex < this.content.data.products.length) {

        // }
      }
      this.activeIndex++;
      this.activeProduct = this.content.data.products[this.activeIndex].product;
    }
    
  }
  public decrementIndex () {
    if (this.activeIndex > 0) {
      if (this.activeIndex === this.lowerIndex) {
        this.upperIndex--;
        this.lowerIndex--;
        // if (this.upperIndex < this.content.data.products.length) {

        // }
      }
      this.activeIndex--;
      this.activeProduct = this.content.data.products[this.activeIndex].product;
    }
    
  }

  public setActive(product){
    // console.log("setActive: ", product);
    this.activeProduct = product;
    this.activeIndex = _.findIndex(this.content.data.products, (p)=> p.product.id === this.activeProduct.id);
    // console.log("activeIndex: ", this.activeIndex);
  }

  public more(){
    if (!this.loadingProducts) {
      this.loadingProducts = true;
      this.page++;
      this.cms.getCategoryProducts(this.slug.charAt(0).toUpperCase() + this.slug.slice(1).toLowerCase(), this.page).then((res)=>{
        // console.log("getCategoryProducts: ", res);
        this.products = this.products.concat(res.results);
        this.loadingProducts = false;
      }).catch((e)=>{
        console.error(e);
        this.loadingProducts = false;
        this.page = 100;
      });
    }
    
  }

  constructor(private route: ActivatedRoute, public connectService:ConnectService, private cms: CmsService, private titleService: Title) { }

  ngOnInit() {
    this.page = 1;
    this.slug = this.route.snapshot.paramMap.get('cat');
    this.cms.getCategory(this.slug).subscribe((response) => {
      this.content = response;
      // console.log("Content: ", response);
      let name;
      if (this.content && this.content.data && this.content.data.title) {
        name = this.content.data.title;
      }
      this.titleService.setTitle(name ? `${name} -- ThinSlabz® by Rosetta Stone Group` : 'ThinSlabz®');
      if (this.content.data.products && this.content.data.products.length > 0) {
        this.activeProduct = this.content.data.products[0].product;
        this.activeIndex = 0;
        // console.log("active: ", this.activeProduct);
      }
      
    })   
    this.loadingProducts = true;
    this.cms.getCategoryProducts(this.slug.charAt(0).toUpperCase() + this.slug.slice(1).toLowerCase(), this.page).then((res)=>{
      // console.log("getCategoryProducts: ", res);
      this.products = res.results;
      this.totalPages = res.total_results_size/8;
      this.loadingProducts = false;
    }).catch((e)=>{
      this.page = 100;
      this.loadingProducts = false;
      console.error(e);
    });
  }
}



// WEBPACK FOOTER //
// /tmp/build_0264da94/src/app/products/category/category.component.ts